import { Grid2 as Grid, Typography, useTheme } from '@mui/material';
import { memo } from 'react';

import { InfoTileProps } from './types';
import { Icon } from '../../../Icon/Icon';

const DatasetDetailsModalContent = ({ id, icon, detailName, detailValue }: InfoTileProps) => {
  const theme = useTheme();

  return (
    <div>
      <Grid
        sx={{
          wordBreak: 'break-word',
          whiteSpace: 'normal',
        }}
        container
        spacing={2}
        wrap={'nowrap'}
      >
        <Icon id="info-tile-icon" icon={icon} sx={{ fill: theme.palette.text.primary }} />

        <Grid sx={{ lineHeight: '100%' }}>
          <Typography
            data-testid={`info-tile-${id}-value`}
            textOverflow={'ellipsis'}
            variant="body2"
            lineHeight={'20px'}
            sx={{ color: theme.palette.text.primary, lineHeight: '20px' }}
          >
            {detailValue || '-'}
          </Typography>

          <Typography
            data-testid={`info-tile-${id}-label`}
            variant="caption"
            sx={{ color: theme.palette.text.secondary, lineHeight: '20px' }}
          >
            {detailName}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(DatasetDetailsModalContent);
